import {
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  INVENTORY,
  PLACEMENT_TYPE_DEAD_CLOWN,
} from "../helpers/consts";
import { BodyPlacement } from "./BodyPlacement";
import { shuffle } from "../helpers/shuffle";
import CharacterBody from "../components/object-graphics/CharacterBody";
import { TILES } from "../helpers/tiles";
import { Collision } from "../classes/Collision";
import sounds, { SFX } from "../classes/Sounds";

export class RoamingEnemyPlacement extends BodyPlacement {
  constructor(properties, level) {
    super(properties, level);
    this.waitFramesBeforeAIMove = 51; //Compensated for ~9 of "post movement lock frames"
    this.framesUntilAiMove = this.waitFramesBeforeAIMove;
    this.enemyTickCheckForHero = true;
  }

  _handleAIMove() {
    const nextDirection = this._getRandomDirection();
    if (nextDirection) {
      if (this._nextSpaceIsFree(nextDirection)) {
        this._move(nextDirection);
      }
    }
  }

  _getRandomDirection() {
    const result = shuffle([
      DIRECTION_RIGHT,
      DIRECTION_UP,
      DIRECTION_LEFT,
      DIRECTION_DOWN,
    ]).find((candidate) => {
      //Do not allow movement to Hero when waiting in teleport (lets the Hero stay safe in there)
      const collision = new Collision(this, this.level);
      collision.offsetPositionInDirection(this.x, this.y, candidate);
      const hasHeroWaitingInsideTeleport =
        collision.withTeleportTile() && collision.withBodyDamagesOther();
      if (hasHeroWaitingInsideTeleport) {
        return false;
      }

      //Return the first space that is free
      return this._nextSpaceIsFree(candidate);
    });
    return result;
  }

  // damagesBodyOnCollide(forBody) {
  //   return false; //TODO
  //   return forBody.type === PLACEMENT_TYPE_HERO;
  // }

  handleEnemyCollideWithHero() {
    //"kill clown" block
    if (this.level.inventory.has(INVENTORY.CLOWN_DEFENSE)) {
      this.enemyTickCheckForHero = false;
      this.level.spawnLivePlacement({
        type: PLACEMENT_TYPE_DEAD_CLOWN,
        x: this.x,
        y: this.y,
      });
      this.level.removeLivePlacement(this);
      this.level.inventory.remove(INVENTORY.CLOWN_DEFENSE);
      sounds.playSfx(SFX.ICE); //Until we have a better sfx
      return;
    }

    //Default to defeating hero as normal
    this.level.setDeathType(this.type);
  }

  renderComponent() {
    return (
      <CharacterBody
        bodyFrameCoord={TILES.ENEMY_ROAMING}
        hop={true}
        movingPixelsRemaining={this.movingPixelsRemaining}
      />
    );
  }
}
